import { ethers, providers } from "ethers";
import React, { useCallback, useEffect, useState } from "react";
import "./App.css";
import abi from "./utils/HeyPortal.json";

const App = () => {
  // State variables to store our user's public wallet
  const [currentAccount, setCurrentAccount] = useState("");
  const [allHeys, setAllHeys] = useState([]);
  const contractAddress = "0xc1257C1a93be72fA9d9840FBFDDD7D338942938b";
  const contractABI = abi.abi;
  let count;

  // Check to see if a wallet is connected
  const checkIfWalletIsConnected = async () => {
    try {
      // Make sure we have access to window.ethereum
      const { ethereum } = window;

      if (!ethereum) {
        console.log("Make sure you have MetaMask");
        return;
      } else {
        console.log("We have the ethereum object", ethereum);
      }

      // Check if we're authorized to access the user's wallet
      const accounts = await ethereum.request({ method: "eth_accounts" });

      if (accounts.length !== 0) {
        const account = accounts[0];
        console.log("Found an authorized account:", account);
        setCurrentAccount(account);
        getAllHeys();
      } else {
        console.log("No authorized accounts found");
      }
    } catch (error) {
      console.error(error);
    }
  };

  // Implement the connectWallet method here
  const connectWallet = async () => {
    try {
      const { ethereum } = window;
      if (!ethereum) {
        alert("Please install MetaMask");
        return;
      }

      const accounts = await ethereum.request({
        method: "eth_requestAccounts",
      });

      console.log("Connected", accounts[0]);
      setCurrentAccount(accounts[0]);
    } catch (error) {
      console.error(error);
    }
  };

  // Get all heys from the contract
  const getAllHeys = async () => {
    const { ethereum } = window;
    try {
      if (ethereum) {
        const provider = new ethers.providers.Web3Provider(ethereum);
        const signer = provider.getSigner();
        const heyPortalContract = new ethers.Contract(
          contractAddress,
          contractABI,
          signer
        );

        // Call the method from the contract
        const heys = await heyPortalContract.getAllHeys();

        // Get the address, timestamp, and message
        let heysCleaned = [];
        for await (const hey of heys) {
          heysCleaned.push({
            name: await provider.lookupAddress(hey.waver),
            address: hey.waver,
            timestamp: new Date(hey.timestamp * 1000),
            message: hey.message,
          });
        }

        // Store the data in React State
        setAllHeys(heysCleaned);
      } else {
        console.log("No ethereum object");
      }
    } catch (error) {
      console.error(error);
    }
  };

  // Listen for emitter events from our smart contract
  useEffect(() => {
    let heyPortalContract;
    const provider = new ethers.providers.Web3Provider(window.ethereum);

    const onNewHey = (from, timestamp, message) => {
      console.log(
        "New hey from",
        from,
        "at",
        timestamp,
        "with message",
        message
      );
      setAllHeys(async (prevState) => [
        ...prevState,
        {
          name: await provider.lookupAddress(hey.waver),
          address: from,
          timestamp: new Date(timestamp * 1000),
          message: message,
        },
      ]);
    };

    if (window.ethereum) {
      const provider = new ethers.providers.Web3Provider(window.ethereum);
      const signer = provider.getSigner();

      heyPortalContract = new ethers.Contract(
        contractAddress,
        contractABI,
        signer
      );
      heyPortalContract.on("NewHey", onNewHey);
    }

    return () => {
      if (heyPortalContract) {
        heyPortalContract.off("NewHey", onNewHey);
      }
    };
  }, []);

  // Send a hey
  const hey = useCallback(
    (msg) => async () => {
      try {
        const { ethereum } = window;

        if (ethereum) {
          const provider = new ethers.providers.Web3Provider(ethereum);
          const signer = provider.getSigner();
          const heyPortalContract = new ethers.Contract(
            contractAddress,
            contractABI,
            signer
          );

          count = await heyPortalContract.getTotalHeys();
          console.log("Retrieved total hey count...", count.toNumber());

          // Execute the actual hey from our smart contract
          const heyTxn = await heyPortalContract.hey(msg, { gasLimit: 300000 });
          console.log("Mining...", heyTxn.hash);

          await heyTxn.wait();
          console.log("Mined -- ", heyTxn.hash);

          count = await heyPortalContract.getTotalHeys();
          console.log("Retrieved total hey count...", count.toNumber());
        } else {
          console.log("Ethereum object doesn't exist");
        }
      } catch (error) {
        console.error(error);
      }
    },
    []
  );

  // Function runs when the page loads
  useEffect(() => {
    checkIfWalletIsConnected();
  }, []);

  // Front End
  return (
    <div className="mainContainer">
      <div className="dataContainer">
        <a href="https://saikambampati.com">
          <img
            className="logo"
            src="https://www.saikambampati.com/_next/image?url=https%3A%2F%2Fapi.typedream.com%2Fv0%2Fdocument%2Fpublic%2F3e8ab94d-260e-4763-9a1a-dfcc91a0b1b2_Group_png.png&w=256&q=75"
            alt="logo"
          />
        </a>
        <div className="header"> Hey 👋 I'm Sai!</div>
        <div className="bio">
          Now that 2022 is shaping up to be a big year for Web 3.0, I figured I
          should learn the fundamentals like how to deploy a smart contract on
          the Ethereum blockchain and make decentralized apps.
          <br />
          <br />
          And that's what this is! My very first, very simple decentralized app
          built with some guidance from the wonderful community{" "}
          <a href="https://buildspace.so/" target="_blank">
            Buildspace
          </a>
          . Think of it as the "Hello World" of building decentralized
          applications.
          <br />
          <br />
          So here's the deal. My social handle across the web{" "}
          <a href="twitter.com/heysaik" target="_blank">
            @heysaik
          </a>{" "}
          so I figured, why not create a place where anyone can drop a "Hey!" to
          me. Best of all, it'll be stored on the Ethereum blockchain forever,
          completely decentralized and ever lasting 😄
          <br />
          <br />
          So if you've got an account on MetaMask, connect your wallet below and
          join some other people who have dropped a "Hey!" to me. There's a 42%
          probability you may win a small amount of ETH too! Make sure you're on
          the Rinkeby network.
        </div>

        {/* If there is an account, render this array of buttons */}
        {currentAccount && (
          <div className="buttonContainer">
            <button
              className="heyButton"
              onClick={hey("Hey")}
              style={{ backgroundColor: "#00a87a" }}
            >
              Hey
            </button>
            <button
              className="heyButton"
              onClick={hey("👋")}
              style={{ backgroundColor: "#4c8bf5" }}
            >
              👋
            </button>
            <button
              className="heyButton"
              onClick={hey("Hallo")}
              style={{ backgroundColor: "#fcba03" }}
            >
              Hallo
            </button>
            <button
              className="heyButton"
              onClick={hey("Salut")}
              style={{ backgroundColor: "#E50914" }}
            >
              Salut
            </button>
            <button
              className="heyButton"
              onClick={hey("Hej")}
              style={{ backgroundColor: "#F56040" }}
            >
              Hej
            </button>
            <button
              className="heyButton"
              onClick={hey("Oi")}
              style={{ backgroundColor: "#FF00BF" }}
            >
              Oi
            </button>
            <button
              className="heyButton"
              onClick={hey("Anyoung")}
              style={{ backgroundColor: "#653819" }}
            >
              Anyoung
            </button>
            <button
              className="heyButton"
              onClick={hey("Ahlan")}
              style={{ backgroundColor: "#833AB4" }}
            >
              Ahlan
            </button>
          </div>
        )}

        {currentAccount && (
          <div className="header-2">
            <br />
            Logs 🪵
          </div>
        )}

        {currentAccount && (
          <div className="bio">
            A list of all the people who've sent a "Hey" to me here!
          </div>
        )}

        {allHeys.reverse().map((hey, index) => {
          if (hey.message === "Hey") {
            return (
              <div
                key={index}
                className="logContainer"
                style={{ backgroundColor: "#00a87a" }}
              >
                <div className="body">
                  <a
                    href={`https://rinkeby.etherscan.io/address/${hey.address}`}
                    target={`_blank`}
                    style={{ color: "white" }}
                  >
                    {hey.name === null ? hey.address : hey.name}
                  </a>{" "}
                  said <b>{hey.message}</b> at {hey.timestamp.toLocaleString()}
                </div>
              </div>
            );
          } else if (hey.message === "👋") {
            return (
              <div
                key={index}
                className="logContainer"
                style={{ backgroundColor: "#4c8bf5" }}
              >
                <div className="body">
                  <a
                    href={`https://rinkeby.etherscan.io/address/${hey.address}`}
                    target={`_blank`}
                    style={{ color: "white" }}
                  >
                    {hey.name === null ? hey.address : hey.name}
                  </a>{" "}
                  said <b>{hey.message}</b> at {hey.timestamp.toLocaleString()}
                </div>
              </div>
            );
          } else if (hey.message === "Hallo") {
            return (
              <div
                key={index}
                className="logContainer"
                style={{ backgroundColor: "#fcba03" }}
              >
                <div className="body">
                  <a
                    href={`https://rinkeby.etherscan.io/address/${hey.address}`}
                    target={`_blank`}
                    style={{ color: "white" }}
                  >
                    {hey.name === null ? hey.address : hey.name}
                  </a>{" "}
                  said <b>{hey.message}</b> at {hey.timestamp.toLocaleString()}
                </div>
              </div>
            );
          } else if (hey.message === "Salut") {
            return (
              <div
                key={index}
                className="logContainer"
                style={{ backgroundColor: "#E50914" }}
              >
                <div className="body">
                  <a
                    href={`https://rinkeby.etherscan.io/address/${hey.address}`}
                    target={`_blank`}
                    style={{ color: "white" }}
                  >
                    {hey.name === null ? hey.address : hey.name}
                  </a>{" "}
                  said <b>{hey.message}</b> at {hey.timestamp.toLocaleString()}
                </div>
              </div>
            );
          } else if (hey.message === "Hej") {
            return (
              <div
                key={index}
                className="logContainer"
                style={{ backgroundColor: "#F56040" }}
              >
                <div className="body">
                  <a
                    href={`https://rinkeby.etherscan.io/address/${hey.address}`}
                    target={`_blank`}
                    style={{ color: "white" }}
                  >
                    {hey.name === null ? hey.address : hey.name}
                  </a>{" "}
                  said <b>{hey.message}</b> at {hey.timestamp.toLocaleString()}
                </div>
              </div>
            );
          } else if (hey.message === "Oi") {
            return (
              <div
                key={index}
                className="logContainer"
                style={{ backgroundColor: "#FF00BF" }}
              >
                <div className="body">
                  <a
                    href={`https://rinkeby.etherscan.io/address/${hey.address}`}
                    target={`_blank`}
                    style={{ color: "white" }}
                  >
                    {hey.name === null ? hey.address : hey.name}
                  </a>{" "}
                  said <b>{hey.message}</b> at {hey.timestamp.toLocaleString()}
                </div>
              </div>
            );
          } else if (hey.message === "Anyoung") {
            return (
              <div
                key={index}
                className="logContainer"
                style={{ backgroundColor: "#653819" }}
              >
                <div className="body">
                  <a
                    href={`https://rinkeby.etherscan.io/address/${hey.address}`}
                    target={`_blank`}
                    style={{ color: "white" }}
                  >
                    {hey.name === null ? hey.address : hey.name}
                  </a>{" "}
                  said <b>{hey.message}</b> at {hey.timestamp.toLocaleString()}
                </div>
              </div>
            );
          } else if (hey.message === "Ahlan") {
            return (
              <div
                key={index}
                className="logContainer"
                style={{ backgroundColor: "#833AB4" }}
              >
                <div className="body">
                  <a
                    href={`https://rinkeby.etherscan.io/address/${hey.address}`}
                    target={`_blank`}
                    style={{ color: "white" }}
                  >
                    {hey.name === null ? hey.address : hey.name}
                  </a>{" "}
                  said <b>{hey.message}</b> at {hey.timestamp.toLocaleString()}
                </div>
              </div>
            );
          }
        })}

        {/* If there is no account, render this button */}
        {!currentAccount && (
          <button className="connectButton" onClick={connectWallet}>
            Connect with MetaMask
          </button>
        )}
      </div>
    </div>
  );
};

export default App;
